"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIVE_SECONDS = exports.TEN_SECONDS = exports.THIRTY_SECONDS = exports.FIVE_MINUTES = exports.SIX_HOURS = exports.ONE_DAY = exports.SEVEN_DAYS = exports.THREE_WEEKS = exports.THIRTY_DAYS = void 0;
exports.THIRTY_DAYS = 2592000;
exports.THREE_WEEKS = 1814400;
exports.SEVEN_DAYS = 604800;
exports.ONE_DAY = 86400;
exports.SIX_HOURS = 21600;
exports.FIVE_MINUTES = 300;
exports.THIRTY_SECONDS = 30;
exports.TEN_SECONDS = 10;
exports.FIVE_SECONDS = 5;
//# sourceMappingURL=time.js.map